import { motion } from "framer-motion";
import './joy-avatar.scss';

interface JoyAvatarProps {
    delay?: number; // Optional delay for animation
    size?: "small" | "medium" | "large" |"chat"; // Add size prop
    className?:any;
}

export default function JoyAvatar({ delay = 0.5, size = "medium" ,className = ""}: JoyAvatarProps) {
    // Determine the size class based on the size prop
    const sizeClass = size === "small" ? "joy-avatar-small" :
                      size === "large" ? "joy-avatar-large" : size === "chat"?"joy-avatar-chat" : "joy-avatar-medium";

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.2, ease: "easeInOut", delay }}
            className={`joy-avatar ${sizeClass}` +" "+className} // Apply the size class
        >
            Z
        </motion.div>
    );
}
